import type { Severity } from '@sentry/types';

export const SENTRY_TAG_TEAM_NAME = 'team';
export const SENTRY_TAG_PACKAGE_NAME = 'package';

/**
 * Необходимый дубль чтобы не добавлять из-за enum Severity
 * весь пакет как deps а не devDeps
 */
export const SentrySeverity = {
    Fatal: 'fatal' as Severity.Fatal,
    Error: 'error' as Severity.Error,
    Warning: 'warning' as Severity.Warning,
    Log: 'log' as Severity.Log,
    Info: 'info' as Severity.Info,
    Debug: 'debug' as Severity.Debug,
    Critical: 'critical' as Severity.Critical,
};

export const TeamNameTag = {
    investments: 'investments',
    alfaleasing: 'alfaleasing',
    autocredit: 'autocredit',
    cc: 'cc',
    common: 'common',
    cpas: 'cpas',
    dc: 'dc',
    deprecated: 'deprecated',
    invest: 'invest',
    mortgage: 'mortgage',
    mvno: 'mvno',
    ['pil-common']: 'pil-common',
    pil: 'pil',
    salary: 'salary',
    ['sme-common']: 'sme-common',
    ['sme-acquiring']: 'sme-acquiring',
    ['sme-credits']: 'sme-credits',
    ['sme-partners']: 'sme-partners',
    ['sme-rko']: 'sme-rko',
    x5bank: 'x5bank',
} as const;

export type TTeamNames = typeof TeamNameTag[keyof typeof TeamNameTag];
